<template>
  <div class="app flex-row align-items-center mt-10">
    <div class="container">
      <v-row class="justify-content-center">
        <v-col md="12">
          <div
            class="clearfix d-flex flex-md-row flex-column justify-space-between"
          >
            <div class="d-flex flex-column">
              <h1 class="display-3 primary--text">404</h1>
              <h4 class="pt-3 mb-5">صفحه مورد نظر شما پیدا نشد!</h4>
            </div>
            <div class="d-flex flex-sm-row flex-column">
              <v-btn class="primary pa-5" @click="goToHome()">
                <v-icon class="me-1">mdi-home-outline</v-icon>
                بازگشت به خانه
              </v-btn>
              <v-btn class="warning ms-sm-2 ms-0 mt-sm-0 mt-2 pa-5" @click="goBack()">
                <v-icon class="me-1">mdi-arrow-left-circle-outline</v-icon>
                بازگشت به صفحه قبل
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "Page404",

  methods: {
    goToHome() {
      let selectedPie = localStorage.getItem("selectedPie");

      selectedPie
        ? this.$router.push("/home/" + selectedPie)
        : this.$router.push("/home");
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
